export const googleApiKey = "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
export const googleAnalyticsMeasurmentId = process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID||"";
export const facebookPixelId = process.env.REACT_APP_FACEBOOK_PIXEL_ID||"";
export const googleTagManagerId = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID||"";
